import type { IAssetOptions } from '@/interfaces/storageForecasting/IAssetOptions';
import type { IAssetPreset } from '@/interfaces/storageForecasting/IAssetPreset';
import { DEFAULT_ASSET_OPTIONS } from '@/constants/forecasting/assetConstants.ts';

export interface IAssetGroup {
    id: string;
    name: string;
    description?: string;
    icon?: string;
    iconColour?: string;
    assetIds: Array<string>;
    options: IAssetOptions;
}

export function createEmptyStorecastAssetGroup (partial: Pick<IAssetGroup, 'id' | 'name'> & Partial<IAssetGroup>): IAssetGroup {
    return {
        id: partial.id,
        name: partial.name,
        description: partial.description,
        icon: partial.icon ?? 'battery-half',
        iconColour: partial.iconColour ?? 'var(--accentColour)',
        assetIds: partial.assetIds ?? [],
        options: partial.options ?? { ...DEFAULT_ASSET_OPTIONS },
    };
}

export function createAssetGroupFromPreset (preset: IAssetPreset): IAssetGroup {
    return createEmptyStorecastAssetGroup({
        id: preset.id,
        name: preset.name,
        description: preset.description,
        icon: preset.icon,
        iconColour: preset.iconColour,
        assetIds: [...preset.inputIds],
    });
}
